

export default {

    username: {
        presence: true,
        length: {
            minimum: 6,
            message: "must be at least 6 characters"
        },
    },
    name: {
        presence: true,
        length: {
            minimum: 2,
            message: "Must be at least 2 characters"
        }
    },
    street: {
        presence: false,
        length: {
            minimum: 3,
            message: "Must be at least 2 characters"
        }
    }, state: {
        presence: false,
    }, zip: {
        presence: false,

    },
    password: {
        presence: true,
        length: {
            minimum: 6,
            message: "must be at least 6 characters"
        }
    },
    confirmPassword: {
      equality: "password",
    },
    email: {
        presence: true,
        email: {
            message: "This doesn't look like a valid email."
        }
    },
    url: {
        url: true
    },
    createUsername: {
        presence: true,
    }
};

